// eslint-disable-next-line
import './styles/constants.css'

import React from 'react'
import ReactDOM from 'react-dom'
import LoadStyles from '@driftt/tide-core/dist/styles'
import ConnectedApp from '@driftt/traffic-control'
import '@driftt/react-dates/initialize'
import '@driftt/react-dates/lib/css/_datepicker.css'
import config from 'config'
import ActivityApp from 'layouts/App'
import { injectedReducers } from 'slices'
import { filtersMiddleware } from 'slices/filters'

LoadStyles()

ReactDOM.render(
  <ConnectedApp
    epics={[filtersMiddleware]}
    reducers={injectedReducers}
    render={() => <ActivityApp />}
    authClientId={config.AUTH_CLIENT_ID}
    sentryConfig={{ enabled: false }}
    vNext
  />,
  document.getElementById('root')
)
